/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Column Chooser Icon component.
 */
export const ColumnChooserIcon = (props: IconProps) => {
  const {color = dlsColor('grey3'), size = 24} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <ThemeIconProvider name='ColumnChooserIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <line x1='3.75' y1='2.75' x2='3.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <line x1='9.75' y1='2.75' x2='9.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <line x1='21.75' y1='2.75' x2='21.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
        <line x1='15.75' y1='2.75' x2='15.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      </svg>
    )} />
  );
};
